import { styled } from '@mui/material/styles';

var PREFIX = "KMosaicElementDetail";
var classes = {
    header: "".concat(PREFIX, "-header"),
    gridContainer: "".concat(PREFIX, "-gridContainer"),
    headerActionElementGrid: "".concat(PREFIX, "-headerActionElementGrid"),
    headerActionElement: "".concat(PREFIX, "-headerActionElement"),
    content: "".concat(PREFIX, "-content")
};
var StyledKMosaicElementDetail = styled("div")(function (_a) {
    var _b, _c, _d, _e;
    var theme = _a.theme;
    return (_b = {
            backgroundColor: theme.palette.grey[200]
        },
        _b["& .".concat(classes.header)] = {
            position: "relative",
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2)
        },
        _b["& .".concat(classes.gridContainer)] = (_c = {},
            _c[theme.breakpoints.down("sm")] = {
                flexDirection: "column-reverse"
            },
            _c),
        _b["& .".concat(classes.headerActionElementGrid)] = (_d = {
                flexGrow: 1,
                textAlign: "right"
            },
            _d[theme.breakpoints.down("sm")] = {
                marginBottom: theme.spacing(2)
            },
            _d),
        _b["& .".concat(classes.headerActionElement)] = (_e = {},
            _e[theme.breakpoints.down("sm")] = {
                display: "block",
                width: "100%"
            },
            _e),
        _b["& .".concat(classes.content)] = {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2)
        },
        _b);
});

export { classes, StyledKMosaicElementDetail as default };
//# sourceMappingURL=index.styled.js.map
